import { FC } from 'react';
import { FieldRenderProps } from 'react-final-form';

import { Checkbox, Stack, Typography } from '@thirdspacelearning/library';

interface Props extends FieldRenderProps<boolean> {
    label: string;
}

const CheckboxFinalField: FC<Props> = ({ label, input, meta, ...rest }) => {
    const { checked, onChange } = input;

    return (
        <Stack direction="row" alignItems="center" spacing={1}>
            <Checkbox
                checked={checked}
                color="primary"
                inputProps={{
                    'aria-labelledby': 'checkbox',
                }}
                onChange={(event) => onChange(event)}
                disableRipple
                size="small"
                variant="modern"
                {...rest}
            />
            <Typography variant="body2" fontWeight="SemiBold">
                {label}
            </Typography>
        </Stack>
    );
};

export default CheckboxFinalField;
